jQuery(document).ready(function ($) {
  /* jQuery(document).on('click', '#drawer .quantity-and-remove a', async function(e) {
    e.preventDefault()

    if(jQuery(this).hasClass('minus')) {
      jQuery(this).parent().find('input').val(parseInt(jQuery(this).parent().find('input').val()) - 1)
    } else {
      jQuery(this).parent().find('input').val(parseInt(jQuery(this).parent().find('input').val()) + 1)
    }

    const cartChangeReq = await fetch('/cart/update.json', {
      method: "POST",
      body: new FormData(jQuery(this).parents('form')[0])
    })
    const cartChangeRes = await cartChangeReq.json()

    theme.updateDrawer();
  })

  jQuery(document).on('change', '#drawerNote', async function(e) {
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', { note: jQuery(this).val() });
  })
  
  jQuery('.cart-type--drawer').on('click', function(e) {
    // alert()
    e.preventDefault()
    theme.updateDrawer();
  })
  
  jQuery(document).on('click', '.closeDrawer', function() {
    jQuery('html').addClass('drawer-closing')

    setTimeout(function() {
      jQuery('html').removeClass('drawer-open')
      jQuery('html').removeClass('drawer-closing')
      jQuery('#drawer .drawerWrapper').html('')
      $('.drawerSliderContainer').slick('unslick');
    }, 450)
  })
  
  jQuery(document).on('click', '#drawercartform .button--checkout', function() {
    window.location.href = "/checkout";
  }) */

  jQuery('.cc-announcement--slider').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          vertical: false
        }
      }
    ]
  })

  jQuery(document).on('click', '.klaviyoAddToCart', function() {
    var _learnq = _learnq || [];
    _learnq.push(['track', 'Added to Cart', jQuery(this).data('item')]);

    jQuery(this).next('.button').click();
    if(document.querySelector('cart-drawer')) {
      // document.querySelector('cart-drawer').update()
    }
  })
})

document.addEventListener('readystatechange', function () {
  if (document.readyState == "complete") {
    const squareplacements = document.querySelectorAll('square-placement')
    Array.from(squareplacements).forEach(squareplacement => {
      const style = document.createElement("style")
      style.type = 'text/css';

      style.innerHTML = `
        .afterpay-logo-link {
          margin-left: 0.5em;
        }
        .afterpay-logo {
          display: none
        }
      `;

      squareplacement.shadowRoot.appendChild(style)
    })
  }
})

if (typeof CartDrawer !== "function") {
  class CartDrawer extends HTMLElement {
    constructor() {
      super()
      this.init()

      this.addEventListener('click', (e) => {
        const drawerDimensions = this.drawerWrapper.getBoundingClientRect()
        if (e.clientX < drawerDimensions.left || e.clientX > drawerDimensions.right || e.clientY < drawerDimensions.top || e.clientY > drawerDimensions.bottom) {
          this.close()
        }
      })

      const themeInsurances = theme.insurances
      if(themeInsurances) {
        const themeCart = theme.cart
        const attributesArray = (themeCart['attributes']['insurances'])?.split(':') || []
        let attributes = {
          'insurances': theme.cart.item_count == 0 ? '' : (themeCart['attributes']['insurances'])
        }
        if(theme.cart.item_count == 0) {
        }
        let cartForm = {
          attributes,
          updates: themeInsurances
        }

        const hasMatchingId = (theme.cart.items).some(item => item.id === parseInt(attributesArray[0]))
        if(document.body.classList.contains('template-cart') && !hasMatchingId) {
          cartForm['updates'][parseInt(attributesArray[0])] = parseInt(attributesArray[2])
        }

        if(document.body.classList.contains('template-cart')) {
          if(!hasMatchingId && attributesArray.length > 0) {
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(cartForm)
            })
            .then(response => {
              return response.json();
            })
            .finally(() => {
              window.location.reload()
            })
          }
        } else {
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartForm)
          })
          .then(response => {
            return response.json();
          })
          .finally(() => {
            this.update(false)
          })
        }
      }
    }
    async connectedCallback() {
      this.total_price = 0;
      await this.getCart();
    }
    init() {
      this.drawerWrapper = this.querySelector('.drawerWrapper')

      this.itemControls = this.querySelectorAll('.quantityContole')
      this.items = this.querySelectorAll('[name^="updates"]')
      this.remaining = this.querySelector('.shippingbar .remaining')
      this.checkoutButton = this.querySelector('.button--checkout')
      this.checkInsurance = this.querySelector('.check-insurance')
      this.giftNoteInput = this.querySelector('.gift_note_input')
      this.giftNote = this.querySelector('.gift_note')
      this.slider = this.querySelector('.drawerSliderContainer')
      this.insurance = this.querySelector('.parcel-insurance')
      this.closeDrawer = this.querySelector('.closeDrawer')
      this.drawerNote = this.querySelector('.drawerNote')
      this.form = this.querySelector('form')

      if (this.remaining) this.remaining.innerHTML = theme.Shopify.formatMoney((parseFloat(this.remaining.textContent)) * Shopify.currency.rate, theme.money_format_with_code_preference)
      this.initialActions()

      const cartButtons = document.querySelectorAll('.cart-type--drawer')
      Array.from(cartButtons).forEach(cartButton => {
        cartButton.addEventListener('click', (e) => {
          if(!cartButton.closest('.template-cart')) {
            e.preventDefault()
            this.show()
          }
        })
      })
    }
    initialActions() {
      if (this.drawerNote) {
        this.drawerNote.addEventListener('change', async () => {
          this.dataset.loading = true
          const noteReq = await fetch('/cart/update.json', {
            method: "POST",
            body: this.drawerNote.value
          })
          const noteRes = await noteReq.json()
          this.dataset.loading = false
        })
      }

      if (this.closeDrawer) {
        this.closeDrawer.addEventListener('click', () => {
          this.close()
        })
      }

      if (this.insurance) {
        this.insurance.addEventListener('change', async () => {
          this.dataset.loading = true
          const insurances = theme.insurancesPlans;
          const attributes = {
            'insurances': ''
          };
          if (this.insurance.checked) {
            Object.entries(insurances).forEach(([key, val]) => {
              const cartTotalPrice = this.total_price - val.price
              if((cartTotalPrice > val.min && val.min > val.max) || (cartTotalPrice > val.min && val.max > cartTotalPrice)) {
                attributes['insurances'] = `${key}:${val.price}:1`
              }
            });
          }
          const updateReq = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes,
              'sections': ['drawer']
            })
          });
          const updateRes = await updateReq.json()
          this.update(false)
        })
      }

      if(this.checkoutButton) {
        this.checkoutButton.addEventListener('click', (e) => {
          if(theme.cart['attributes']['insurances']) {
            e.preventDefault()
            const attributesArray = (theme.cart['attributes']['insurances']).split(':')

            let formData = new FormData();
            formData.append(`updates[${attributesArray[0]}]`, attributesArray[2]);
            this.dataset.loading = true
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData
            }).then(response => response.json()).then(data => {
              this.checkoutButton.closest('form').submit()
            });
          }
        })
      }

      Array.from(this.itemControls).forEach(itemControl => {
        itemControl.addEventListener('click', async (e) => {
          e.preventDefault()
          const valInput = itemControl.closest('.quantity').querySelector('input')
          const itemControlID = itemControl.closest('.drawer-cart-item').dataset.id
          const cal = itemControl.classList.contains('quantityMinus') ? -1 : 1

          valInput.value = parseInt(valInput.value) + cal

          const insurances = theme.insurances;
          
          if (insurances && Object.keys(insurances).includes(itemControlID) && parseInt(valInput.value) === 0) {
            let formData = new FormData();
            formData.append(`attributes[insurances]`, "");
            formData.append(`updates`, JSON.stringify(theme.insurances));
            if (this.insurance) this.insurance.checked = false;
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData
            }).then(res => res.json()).then(res => {
              this.update()
            });
            // this.insurance.click()
          } else {
            let formData = new FormData();
            Array.from(this.items).forEach(i => {
              if(!(i.closest('.drawer-cart-insurance'))) formData.append(`updates[${i.dataset.id}]`, i.value);
            })
            formData.append(`attributes[insurances]`, "");

            this.dataset.loading = true

            if(itemControl.closest('.drawer-cart-insurance')) {
              if (this.insurance && this.insurance.checked) {
                const insurancesPlans = theme.insurancesPlans;
                let insuranceformData = new FormData();
                let insuranceQty = Object.keys(insurances).includes(itemControlID) ? valInput.value : 1;

                if (insurancesPlans) {
                  Object.entries(insurancesPlans).forEach(([key, val]) => {
                    // if((theme.cart.total_price > val.min && val.min > val.max) || (theme.cart.total_price > val.min && val.max > theme.cart.total_price)) {
                    if(this.total_price >= val.min && (!val.max || this.total_price < val.max)) {
                      insuranceformData.append(`attributes[insurances]`, `${key}:${val.price}:${insuranceQty}`);
                    }
                  });
                }

                fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  body: insuranceformData
                }).then(response => response.json()).then(data => this.update());
              }
            } else {
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
              }).then(res => res.json()).then(res => {
                this.update()
              });
            }
          }
        })
      })

      if (this.giftNoteInput) this.giftNoteInput.addEventListener('change', () => {
        let formData = new FormData();
        this.giftNote.innerHTML = ""
        formData.append(`updates[${this.giftNoteInput.dataset.id}]`, this.giftNoteInput.checked ? 1 : 0);
        formData.append(`attributes[Gift Note]`, this.giftNote.value);

        this.dataset.loading = true
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        }).then(response => response.json()).then(data => this.update());
      })

      if (this.giftNote) (
        this.giftNote.addEventListener('input', () => {
          if (this.giftNote.value.length > 300) {
            this.giftNote.value = this.giftNote.value.slice(0, 300);
          }
        }),
        this.giftNote.addEventListener('change', () => {
          let formData = new FormData();

          formData.append(`attributes[Gift Note]`, this.giftNote.value);

          this.dataset.loading = true
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData
          }).then(response => response.json()).then(data => this.update());
        })
      )
    }
    async update(show = true) {
      if (show) {
        this.show()
      }
      this.dataset.loading = true
      await this.getCart();
      const req = await fetch(window.Shopify.routes.root + 'cart/update.json')
      theme.cart = await req.json()
      await this.render()
      this.init()
      this.dataset.loading = false

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const cartButton = mutation.target.querySelector('.cart-type--drawer')
          if(cartButton) {
            cartButton.addEventListener('click', (e) => {
              e.preventDefault()
              this.show()
            })
          }
        })
      })
      const config = {
        childList: true,
        subtree: true,
      }
      observer.observe(document.querySelector('.nav-right-side'), config)
    }
    async render() {
      const drawerReq = await fetch('/pages/cart-drawer?view=cart-ajax')
      const drawerRes = await drawerReq.text()
      const $html = (new DOMParser()).parseFromString(drawerRes, "text/html")

      if(this.drawerWrapper.querySelector('.shippingbar')) this.drawerWrapper.querySelector('.shippingbar').innerHTML = $html.querySelector('.drawerContainer').querySelector('.shippingbar').innerHTML
      if(this.drawerWrapper.querySelector('.cartDrawerForm')) this.drawerWrapper.querySelector('.cartDrawerForm').innerHTML = $html.querySelector('.drawerContainer').querySelector('.cartDrawerForm').innerHTML

      // this.querySelector('.drawerWrapper').innerHTML = $html.querySelector('.drawerContainer').querySelector('.drawerWrapper').innerHTML

      $.get(theme.routes.cart_url, function (data) {
        var cartUpdateSelector = '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
        var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartUpdateSelector);
        $(cartUpdateSelector).each(function (index) {
          $($newCartObj[index]).find('[data-cc-animate]').removeAttr('data-cc-animate');
          $(this).replaceWith($newCartObj[index]);
          $(this).parent().find('[data-cc-animate]').removeAttr('data-cc-animate');
        });
      });
    }
    renderSlider() {
      jQuery(this.slider).slick({
        arrows: true,
        dots: false,
        infinite: true,
        nextArrow: '<svg class="slickArrow slickArrowRight" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 215 370.8"><polygon points="165.3,185.4 0,346 24.1,370.8 215,185.4 24.1,0 0,24.8"/></svg>',
        prevArrow: '<svg class="slickArrow slickArrowLeft" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 215 370.8"><polygon points="215,24.8 190.9,0 0,185.4 190.9,370.8 215,346 49.7,185.4"/></svg>',
        slidesToScroll: 1,
        slidesToShow: 3,
      })
    }
    close() {
      const el = window.getComputedStyle(this.drawerWrapper)
      const delay = (el['animation-duration']).includes("ms") ? parseInt(el['animation-duration']) : parseFloat(el['animation-duration']) * 1000

      document.body.classList.add('drawer-closing')

      setTimeout(() => {
        document.body.classList.remove('drawer-closing', 'drawer-open')
      }, delay);
    }
    async show() {
      await this.getCart();
      if (this.insurance && this.insurance.checked) {
        const attributesArray = (theme.cart['attributes']['insurances']).split(':')
        const insurances = theme.insurances;
        const insurancesPlans = theme.insurancesPlans;
        let insuranceformData = new FormData();
        let insuranceQty = Object.keys(insurances).includes(attributesArray[0]) ? attributesArray[2] : 1;

        if (insurancesPlans) {
          Object.entries(insurancesPlans).forEach(([key, val]) => {
            // if((theme.cart.total_price > val.min && val.min > val.max) || (theme.cart.total_price > val.min && val.max > theme.cart.total_price)) {
            if((this.total_price >= val.min && (!val.max || this.total_price < val.max))) {
              insuranceformData.append(`attributes[insurances]`, `${key}:${val.price}:${insuranceQty}`);
              theme.cart['attributes']['insurances'] = `${key}:${val.price}:${insuranceQty}`
            }
          });
        }

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: insuranceformData
        }).then(response => response.json()).then(data => this.update(false));
        console.log(theme.cart);
      }
      document.body.classList.add('drawer-open')
      this.renderSlider()
    }
    async getCart() {
      const cartReq = await fetch(window.Shopify.routes.root + 'cart.json');
      const cartRes = await cartReq.json();
      this.total_price = cartRes.total_price
    }
  }
  customElements.define("cart-drawer", CartDrawer)
}

const cartButtons = document.querySelectorAll('.cart-type--drawer')
Array.from(cartButtons).forEach(cartButton => {
  cartButton.addEventListener('click', (e) => {
    e.preventDefault()

    if(document.querySelector('cart-drawer')) {
      document.querySelector('cart-drawer').show()
    } else {
      window.location.href = "/cart"
    }
  })
})